import { AgmInfoWindow } from '@agm/core';
import {
  Component,
  ElementRef,
  OnInit,
  ViewChild,
  ViewEncapsulation,
  Inject,
  ComponentFactoryResolver,
  Injector,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { BaseComponent } from 'common/components/base.component';
import { EventLocationAdding } from '../event.add.location';
import { EventPageAdding } from '../event.add.page';
import { AddressInputComponent } from 'common/components/address.input/address.input.component';
import { HubFeed } from 'models/hub/hub.feed';
import {
  HubVisitorFeatureToggle,
  HubVisitorToggleDataSource,
} from 'models/hub/hub.visitor.feature.toggle';
import { HubApiService } from 'services/hub.api.service';
import { AlertifyService } from 'services/alertify.service';
import { HubComponent } from 'components/hub/hub.component';
import { ModalService } from 'common/services/modal.service';
import {
  ToggleAndDataSourceStore,
  HubFacebookPageFeedsStore,
  HubFacebookLocationFeedsStore,
  PDFSettingsStore,
} from 'stores/hub.calendar.store';
import {
  HubFacebookFeedsCommand,
  AddFacebookGeneralFeedCommand,
} from 'commands/hub/event/add.facebook.general.feed.command';
import { PullGooglePlaceTypeModalActions } from 'components/hub/pull.google.place.type.modal/pull.google.place.type.modal.provider';
import { localStorageKeys } from 'common/constants/local.storage.keys';
import { PullGooglePlaceTypeModalComponent } from 'components/hub/pull.google.place.type.modal/pull.google.place.type.modal.component';
import { ButtonTriggerEvent } from 'common/components/button/button.component';
import {
  ConfirmModalData,
  ConfirmModalActions,
} from 'common/components/confirm.modal/confirm.modal.provider';
import { AddEventBriteGeneralFeedCommand } from 'commands/hub/event/add.eventbrite.general.feed.command';
import { ConfirmModalComponent } from 'common/components/confirm.modal/confirm.modal.component';
import { constantTooltip } from 'common/constants/constant.tooltip';
import { ConfigService } from 'services/config.service';
import { AddFacebookLocationFeedCommand } from 'commands/hub/event/add.facebook.location.feed.command';
import { GeoService } from 'services/geo.service';
import { config } from '../../../../../config/config';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { EditPlaceModalComponent } from '../../edit.place.modal/edit.place.modal.component';
import { EditPlaceModalActions } from '../../edit.place.modal/edit.place.modal.provider';
import { HubPlace } from '../../../../models/hub/hub.place';
import { InputModalComponent } from '../../../../common/components/input.modal/input.modal.component';
import {
  InputModalActions,
  InputModalData,
} from '../../../../common/components/input.modal/input.modal.provider';
import { CropperSettings } from 'ngx-img-cropper';
import { PDFSettingCommand } from '../../export.pdf.modal/export.pdf.modal.provider';
import { ImageService } from '../../../../services/image.service';
import { CustomizationApiService } from '../../../../services/customization.api.service';
import { MatTabGroup } from '@angular/material';
import { isNullOrUndefined } from 'util';
import { SuccessWrapComponent } from '../../../../common/components/success.wrap/success.wrap.component';
import { ImageCropperWithPreviewComponent } from '../../../../common/components/image.cropper/image.cropper.component';
import { ShowInfoModalComponent } from '../../show.info.modal/show.info.modal.component';
import {
  InfoModalData,
  ShowInfoModalActions,
} from '../../show.info.modal/show.info.modal.provider';
import { BulkAIDescriptionsStore } from '../../../../stores/hub.calendar.store';
import { BulkAIDescriptionsModalComponent } from '../../bulk.ai.descriptions.modal/bulk.ai.descriptions.modal.component';
import * as jwt_decode from 'jwt-decode';
import { TokenInfo } from '../../../../models/auth/token.info';

@Component({
  selector: 'ig-content-management',
  templateUrl: './content.management.component.html',
  styleUrls: ['./content.management.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ContentManagementComponent extends BaseComponent implements OnInit {
  public eventPage = new EventPageAdding();
  public placePageFacebook = new EventPageAdding();
  public eventLocation = new EventLocationAdding();
  public locationPlaceId = null;
  public locationPlaceCityState = null;
  public eventFormGroup: FormGroup;
  public placeFacebookFormGroup: FormGroup;
  public locationFormGroup: FormGroup;
  public hubName: string;
  public pageSource = 'eventful';
  public locationSource: string;
  public zoom = ConfigService.config.google.fullUSMapZoom;
  public isShowMarker = false;
  public isFeedExisted = false;
  public isLoadingFeeds = false;
  public inAddingLocationFeed = false;
  public isLoadingPlaceSource = false;
  public placeSource = 'facebook';
  public showSuccessInfo = false;
  public percentage = null;
  public autoCompletedAddress: any;
  public mileToMeters = config.mileToMeters;
  @ViewChild('infoWindow') infoWindow: AgmInfoWindow;
  @ViewChild('addressInput') addressInput: AddressInputComponent;
  @ViewChild('tab') tab: MatTabGroup;
  @ViewChild('savepdfsuccess') public savePDFScussess: SuccessWrapComponent;
  @ViewChild('eventImgCropper') eventImgCropper: ImageCropperWithPreviewComponent;
  @ViewChild('placeImgCropper') placeImgCropper: ImageCropperWithPreviewComponent;
  public hubPages: HubFeed[];
  public hubLocations: HubFeed[];
  public isLoadingSpiderEventPages = false;
  public spiderEventPages = [];
  public pagesMax = config.maxLocationFeedLimit;
  public pageTooltip: string;
  public toggles = new HubVisitorFeatureToggle();
  public isKeepTempClosedPlaceInApproved = false;
  public selectedGoogleCategories = [];
  public sourceItems: any;
  public urlSourceItems = [
    // {
    //     text: 'Eventbrite',
    //     value: 'eventbrite'
    // },
    {
      text: 'Eventful',
      value: 'eventful',
    },
  ];
  public maxCroppedWidth = 800;
  public cropperSettingsForPDF: CropperSettings;
  public PDFSettings: PDFSettingCommand;
  public PDFSettingImageCorperData: {
    event: any;
    place: any;
    tour: any;
    trip: any;
  };
  public placeLocationFilters = [];
  public eventLocationFilters = [];

  constructor(
    private router: Router,
    private formBuilder: FormBuilder,
    private hubApiService: HubApiService,
    private activatedRoute: ActivatedRoute,
    private alertify: AlertifyService,
    private modalService: ModalService,
    public dialog: MatDialog,
    private customizationService: CustomizationApiService,
    private imageService: ImageService,
    private parent: HubComponent,
    private pdfSettingsStore: PDFSettingsStore,
    private toggleAndDataSourceStore: ToggleAndDataSourceStore,
    private hubFacebookFeedsStore: HubFacebookPageFeedsStore,
    private hubFacebookLocationFeedsStore: HubFacebookLocationFeedsStore,
    private bulkAIDescriptionsStore: BulkAIDescriptionsStore,
    private componentFactoryResolver: ComponentFactoryResolver,
    private injector: Injector
  ) {
    super({ activatedRoute });
  }

  public ngOnInit() {
    let { hubName } = this.allRouteParams;
    this.hubName = hubName;

    this.eventPage.tags = 'Visitor Posts';
    this.pageSource = 'eventbrite';
    this.changeTooltip();
    this.cropperSettingsForPDF = new CropperSettings();
    this.PDFSettings = {
      pdf: {
        headerImage: {
          event: { isDefault: true, url: null },
          place: { isDefault: true, url: null },
          tour: { isDefault: true, url: null },
          trip: { isDefault: true, url: null },
        },
      },
      eventCalendarURL: null,
      placeCalendarURL: null,
      moreToursURL: null,
    };
    this.PDFSettingImageCorperData = {
      event: {},
      place: {},
      tour: {},
      trip: {},
    };

    this.eventFormGroup = this.formBuilder.group({
      facebookPageUrlOrName: [null, [Validators.required]],
      displayTitle: [null, null],
      tags: [null, null],
    });
    this.placeFacebookFormGroup = this.formBuilder.group({
      facebookPageUrlOrName: [null, [Validators.required]],
      displayTitle: [null, null],
      tags: [null, null],
    });
    this.locationFormGroup = this.formBuilder.group({
      address: [null, [Validators.required]],
      displayTitle: [null, null],
      filterByCity: [null, null],
      tags: [null, null],
      radius: [null, [Validators.required]],
    });

    this.hubFacebookFeedsStore.pagesCommand
      .takeUntil(this.isDestroyed)
      .subscribe((hubPages: HubFacebookFeedsCommand) => {
        this.hubPages = hubPages.hubPages;
      });

    this.hubFacebookLocationFeedsStore.locationCommand
      .takeUntil(this.isDestroyed)
      .subscribe((hubLocations: HubFacebookFeedsCommand) => {
        this.hubLocations = hubLocations.hubPages;
      });

    this.toggleAndDataSourceStore.toggleAndDataSourceCommand
      .takeUntil(this.isDestroyed)
      .subscribe((toggleCommand: HubVisitorToggleDataSource) => {
        if (toggleCommand.toggle) {
          this.toggles = toggleCommand.toggle;
          this.eventLocation.isFilterByCity = this.toggles.multipleCities;
          this.locationSource = 'eventbrite';
          this.isKeepTempClosedPlaceInApproved = toggleCommand.isKeepTempClosedPlaceInApproved;
          if (toggleCommand && toggleCommand.dataSource) {
            let eventSources = [
              // Eventbrite had turned the event api off
              //     {
              //     text: 'Eventbrite',
              //     value: 'eventbrite',
              //     visible: this.toggles.eventByGeolocation
              // },
              {
                text: 'Performers, Venues, Ticketing Websites',
                value: 'eventful',
                visible: this.toggles.eventByGeolocation,
              },
            ];
            let sourceItems = [];
            if (this.toggles.placeCalendar) {
              if (toggleCommand.dataSource.place === 'facebook') {
                sourceItems = [
                  {
                    text: 'Facebook Places',
                    value: 'facebook',
                    selected: true,
                    //visible: this.toggles.placeCalendar && this.toggles.dataSource.place === 'facebook'
                  },
                ];
              } else if (toggleCommand.dataSource.place === 'google') {
                sourceItems = [
                  {
                    text: 'Google Places',
                    value: 'google',
                    selected: true,
                    //visible: this.toggles.placeCalendar && this.toggles.dataSource.place === 'google'
                  },
                ];
              }
              this.placeSource = toggleCommand.dataSource.place;
              this.locationSource = toggleCommand.dataSource.place;
            }
            // if (this.toggles.eventByGeolocation) {
            //     sourceItems.push(...eventSources);
            // }
            this.sourceItems = sourceItems;
          }
        }
      });

    if (!this.hubLocations || !this.hubLocations.length) {
      //this.loadLocationFeeds();
      this.getHubLocations();
    }

    this.loadSpiderEventPages();
    this.loadPlaceLocationFilters();
    this.loadEventLocationFilters();
    // this.isLoadingPlaceSource = true;
    // this.hubApiService.getDataSource(this.hubName).subscribe(data => {
    //     if (data) {
    //         this.placeSource = data.place;
    //     }
    //     this.isLoadingPlaceSource = false;
    // });
    this.customizationService
      .getPDFSettings(this.hubName)
      .subscribe((settings: PDFSettingCommand) => {
        this.PDFSettings.pdf.headerImage.event.isDefault =
          isNullOrUndefined(settings) ||
          isNullOrUndefined(settings.pdf.headerImage.event.isDefault) ||
          settings.pdf.headerImage.event.isDefault;
        this.PDFSettings.pdf.headerImage.event.url = this.PDFSettings.pdf.headerImage.event
          .isDefault
          ? null
          : settings.pdf.headerImage.event.url;
        if (
          this.PDFSettings.pdf.headerImage.event.url &&
          this.PDFSettings.pdf.headerImage.event.url.length
        ) {
          this.PDFSettingImageCorperData.event.image =
            this.PDFSettings.pdf.headerImage.event.url[0];
        }

        this.PDFSettings.pdf.headerImage.place.isDefault =
          isNullOrUndefined(settings) ||
          isNullOrUndefined(settings.pdf.headerImage.place.isDefault) ||
          settings.pdf.headerImage.place.isDefault;
        this.PDFSettings.pdf.headerImage.place.url = this.PDFSettings.pdf.headerImage.place
          .isDefault
          ? null
          : settings.pdf.headerImage.place.url;
        if (
          this.PDFSettings.pdf.headerImage.place.url &&
          this.PDFSettings.pdf.headerImage.place.url.length
        ) {
          this.PDFSettingImageCorperData.place.image =
            this.PDFSettings.pdf.headerImage.place.url[0];
        }

        this.PDFSettings.pdf.headerImage.tour.isDefault =
          isNullOrUndefined(settings) ||
          isNullOrUndefined(settings.pdf.headerImage.tour.isDefault) ||
          settings.pdf.headerImage.tour.isDefault;
        this.PDFSettings.pdf.headerImage.tour.url = this.PDFSettings.pdf.headerImage.tour.isDefault
          ? null
          : settings.pdf.headerImage.tour.url;
        if (this.PDFSettings.pdf.headerImage.tour.url) {
          this.PDFSettingImageCorperData.tour.image = this.PDFSettings.pdf.headerImage.tour.url;
        }

        this.PDFSettings.pdf.headerImage.trip.isDefault =
          isNullOrUndefined(settings) ||
          isNullOrUndefined(settings.pdf.headerImage.trip.isDefault) ||
          settings.pdf.headerImage.trip.isDefault;
        this.PDFSettings.pdf.headerImage.trip.url = this.PDFSettings.pdf.headerImage.trip.isDefault
          ? null
          : settings.pdf.headerImage.trip.url;
        if (this.PDFSettings.pdf.headerImage.trip.url) {
          this.PDFSettingImageCorperData.trip.image = this.PDFSettings.pdf.headerImage.trip.url;
        }

        setTimeout(() => {
          this.eventImgCropper && this.eventImgCropper.setImageData(this.cropperSettingsForPDF);
          this.placeImgCropper && this.placeImgCropper.setImageData(this.cropperSettingsForPDF);
        });
      });

    setTimeout(() => {
      this.parent.location = 'Events';
    });
    this.setPDFSize();
  }

  private setPDFSize() {
    const rect = this.tab._elementRef.nativeElement.getBoundingClientRect(); //1228 / 2;
    // let width = (rect.width - 18 * 4 - 12) / 2;
    // width = width <= 0 ? window.innerWidth * 0.379 : width;
    const width = window.innerWidth * 0.379;
    const height = (width * 60) / 210;
    this.cropperSettingsForPDF = this.imageService.createImageCropperSetting(width, height, true);
  }

  public loadSpiderEventPages() {
    this.isLoadingSpiderEventPages = true;
    this.hubApiService.getSpiderEventPages(this.hubName).subscribe((data) => {
      this.isLoadingSpiderEventPages = false;
      this.spiderEventPages = data.pages
        .filter((x) => x.socialName.toLowerCase().indexOf('facebook') >= 0)
        .map((x) => {
          return {
            url: x.url.replace('https://facebook.com/', 'https://www.facebook.com/').trim(),
            socialName: x.socialName,
            tag: x.tag,
            _id: x._id,
          };
        })
        .sort((a, b) => {
          return a.url.toLowerCase().localeCompare(b.url.toLowerCase());
        });

      console.log(this.spiderEventPages);
      this.pagesMax = isNullOrUndefined(data.pagesMax)
        ? config.maxLocationFeedLimit
        : data.pagesMax;
    });
  }

  public loadPlaceLocationFilters() {
    this.hubApiService.getPlaceLocationFilters(this.hubName).subscribe((data) => {
      this.placeLocationFilters = data;
    });
  }

  public loadEventLocationFilters() {
    this.hubApiService.getEventLocationFilters(this.hubName).subscribe((data) => {
      this.eventLocationFilters = data;
    });
  }

  public showLocationWidgetUrl(location, type) {
    const link = `<div id="imgoingcalendar-wrapper" route="/${this.hubName}/${type}/location/${location.locality}" url-change="true" version="V3">
        <app-root></app-root> 
        <script type="text/javascript" src="https://imgoingcalendar.com/imgoingscript.js"></script>
    </div>`;

    this.modalService.show({
      component: ShowInfoModalComponent,
      providers: [
        { provide: ShowInfoModalActions, useValue: null },
        {
          provide: InfoModalData,
          useValue: new InfoModalData('Place Location Widget URL', null, [], link, true),
        },
      ],
      panelClass: 'width-modal-70p',
    });
  }

  public get isEventEnabled() {
    return this.toggles.manualEvents || this.toggles.eventByGeolocation;
  }

  public loadLocationFeeds() {
    if (!this.hubLocations || !this.hubLocations.length) {
      this.isLoadingFeeds = true;
      this.hubApiService.getLocationFeeds(this.hubName).subscribe((data) => {
        this.hubLocations = data;
        this.isLoadingFeeds = false;
      });
    }
  }

  public showCategoryPopup() {
    let actions = <PullGooglePlaceTypeModalActions>{
      confirm: (data: any) => {
        this.selectedGoogleCategories = data;
        localStorage.setItem(localStorageKeys.googlePlaceTypeToPull, JSON.stringify(data));
      },
    };

    this.modalService.show({
      component: PullGooglePlaceTypeModalComponent,
      providers: [{ provide: PullGooglePlaceTypeModalActions, useValue: actions }],
      panelClass: 'width-modal-90p',
    });
  }

  public async savePDFEventHeaderImage(event: ButtonTriggerEvent) {
    // let data = new PDFSettingCommand();
    // data.pdf.headerImage.event = {
    //     isDefault: this.PDFSettings.pdf.headerImage.event.isDefault,
    //     url: this.PDFSettingImageCorperData.event.image
    // };
    // data.pdf.headerImage.place = {
    //     isDefault: false,
    //     url: 'not-changed'
    // };

    let data = new PDFSettingCommand();

    if (this.PDFSettings.pdf.headerImage.event.isDefault) {
      this.PDFSettingImageCorperData.event.image = '';
      data.pdf.headerImage.event = {
        isDefault: this.PDFSettings.pdf.headerImage.event.isDefault,
        url: [],
      };
    } else {
      let imageFile = await this.imageService.compressImageFile(
        this.imageService.getImageFileByBase64(this.PDFSettingImageCorperData.event.image),
        1400
      );
      let imageBase64 = await this.imageService.getBase64ByImageFile(imageFile);
      const res = await this.hubApiService.uploadBase64ImageToAWS(imageBase64, 1400);
      const url = res.url;

      data.pdf.headerImage.event = {
        isDefault: this.PDFSettings.pdf.headerImage.event.isDefault,
        url: [url],
      };
    }

    // data.pdf.headerImage.place = {
    //     isDefault: false,
    //     url: 'not-changed'
    // };
    this.customizationService
      .setPDFEventHeaderImage(this.hubName, data.pdf.headerImage.event)
      .finally(event.complete)
      .subscribe(() => {
        this.alertify.successfully('Change the event pdf event header image');
        this.pdfSettingsStore.pdfCommand.next(data);
      });
  }

  public async savePDFPlaceHeaderImage(event: ButtonTriggerEvent) {
    // let data = new PDFSettingCommand();
    // data.pdf.headerImage.place = {
    //     isDefault: this.PDFSettings.pdf.headerImage.place.isDefault,
    //     url: this.PDFSettingImageCorperData.place.image
    // };
    // data.pdf.headerImage.event = {
    //     isDefault: false,
    //     url: 'not-changed'
    // };

    let data = new PDFSettingCommand();

    if (this.PDFSettings.pdf.headerImage.place.isDefault) {
      this.PDFSettingImageCorperData.place.image = '';
      data.pdf.headerImage.place = {
        isDefault: this.PDFSettings.pdf.headerImage.place.isDefault,
        url: [],
      };
    } else {
      let imageFile = await this.imageService.compressImageFile(
        this.imageService.getImageFileByBase64(this.PDFSettingImageCorperData.place.image),
        1400
      );
      let imageBase64 = await this.imageService.getBase64ByImageFile(imageFile);
      const res = await this.hubApiService.uploadBase64ImageToAWS(imageBase64, 1400);
      const url = res.url;

      data.pdf.headerImage.place = {
        isDefault: this.PDFSettings.pdf.headerImage.place.isDefault,
        url: [url],
      };
    }

    // data.pdf.headerImage.event = {
    //     isDefault: false,
    //     url: 'not-changed'
    // };
    this.customizationService
      .setPDFPlaceHeaderImage(this.hubName, data.pdf.headerImage.place)
      .finally(event.complete)
      .subscribe(() => {
        this.alertify.successfully('Change the place pdf event header image');
        this.pdfSettingsStore.pdfCommand.next(data);
      });
  }

  public keepTempClosedInApproved() {
    this.customizationService
      .setIsKeepTempClosedPlaceInApproved(this.hubName, this.isKeepTempClosedPlaceInApproved)
      .subscribe(() => {
        this.alertify.successfully('Change temporarily closed place status');
      });
  }

  public filterPlacesByCity() {
    if (!this.eventLocation.isFilterByCity) {
      this.eventLocation.filterByCity = null;
    } else {
      this.eventLocation.filterByCity = this.locationPlaceCityState; //this.locationPlaceId;
    }
  }

  public bulkGeneration() {
    const modal = document.querySelector('.ig-bulk-ai-descriptions-modal');
    if (modal) {
      modal.classList.add('ig-shake');
      setTimeout(() => {
        modal.classList.remove('ig-shake');
      }, 1000);
      return;
    }

    this.bulkAIDescriptionsStore.bulkAIDescriptionsCommand.next(this.hubName);
    const factory = this.componentFactoryResolver.resolveComponentFactory(
      BulkAIDescriptionsModalComponent
    );
    const componentRef = factory.create(this.injector);

    const appElement = document.querySelector('body');
    const componentRootElement = componentRef.location.nativeElement;
    appElement && appElement.appendChild(componentRootElement);
  }

  public addFBPage(event: ButtonTriggerEvent) {
    let fbID = this.getFBID(this.placePageFacebook.facebookPageUrlOrName);
    if (!fbID) {
      this.modalService.showErrorModal('Please enter a valid facebook page url or name!');
      event.complete();
      return;
    }

    this.hubApiService
      .addFacebookPageFeed(
        this.hubName,
        new AddFacebookGeneralFeedCommand(
          fbID,
          this.placePageFacebook.displayTitle,
          this.placePageFacebook.tags,
          this.hubName
        )
      )
      .finally(event.complete)
      .subscribe((result) => {
        let data = <ConfirmModalData>{
          confirmModalIcon: 'done',
          confirmModalTitle: 'Success',
          confirmModalDescription: 'Added the place of Facebook page success',
          confirmModalCancelButtonText: 'OK',
          isAsync: true,
        };

        if (result && result.error) {
          data.confirmModalTitle = 'Failed';
          data.confirmModalIcon = 'warning';
          if (result.error.code === 100) {
            data.confirmModalDescription =
              "Uh-oh! Check your Facebook page settings! It appears that your page has Country or Age restrictions and we won't be able to retrieve events, according to the Facebook API guidelines.";
          } else if (result.error.code === 803) {
            data.confirmModalDescription = result.error.message.replace('(#803)', 'Uh-oh!');
          } else if (result.error.code === 3333) {
            data.confirmModalDescription =
              '<div>Looks like this page is using a Facebook category that we do not recognize: ' +
              decodeURIComponent(result.error.message) +
              ' <br><br> Here is how you can still promote this business:<br>' +
              'Contact the business to edit their categories (they can add up to three!) <br><a target="_blank" href="../../../assets/pages/recognized.categories.html">View our list of recognized categories</a><br><br>' +
              'OR <br><br>If you feel this category should be included in your ImGoing account, please contact our <a href="mailto:support@iti-digital.zendesk.com?subject=Please Add the Place Category!&body=Please add the place category: ' +
              result.error.message +
              ', for the place: ' +
              fbID +
              '">support team</a></div>';
            this.getHubPageFeeds();
          } else if (result.error.code === 4444) {
            data.confirmModalDescription =
              '<div>Uh-oh! Looks like the Facebook Business Page you are trying to add is not an official Facebook page, or it has no physical address and ImGoing will need that information to display the place on the map!\n' +
              '\n' +
              'We recommend that you contact the business, have them update the physical address on their page, and then try re-adding it here. Contact our team at <a href="mailto:support@iti-digital-zendesk.com">support@iti-digital-zendesk.com</a> if you have any questions!</div>';
            this.getHubPageFeeds();
          } else {
            console.log(result.error.message);
            data.confirmModalDescription =
              'Uh-oh! Please check if this is a correct Facebook place page. Contact our team at <a href="mailto:support@iti-digital-zendesk.com">support@iti-digital-zendesk.com</a> if you have any questions!</div>';
          }
        } else {
          this.placeFacebookFormGroup.markAsPristine();
          this.placePageFacebook.displayTitle = null;
          this.placePageFacebook.facebookPageUrlOrName = null;

          this.getHubPageFeeds();
        }

        let actions = <ConfirmModalActions>{};

        this.modalService.show({
          component: ConfirmModalComponent,
          providers: [
            { provide: ConfirmModalActions, useValue: actions },
            { provide: ConfirmModalData, useValue: data },
          ],
        });
      });
  }

  public tabChanged($event) {
    this.parent.location = $event.tab.textLabel;

    if (!window.location.href.includes('localhost')) {
      const authToken = localStorage.getItem(localStorageKeys.authToken);
      let tokenInfo = jwt_decode<TokenInfo>(authToken);
      try {
        let trackName = 'click - ContentManagement - ' + $event.tab.textLabel;
        window['pendo'].track(trackName, {
          accountId: tokenInfo.userName,
          timestamp: Date.now(),
          hubName: this.hubName,
        });
      } catch (error) {
        console.error(error);
      }
    }
  }

  public addEventPage() {
    if (this.checkIfExceedLimit('spider')) {
      return;
    }
    let actions = <InputModalActions>{
      confirm: (event: ButtonTriggerEvent, url) => {
        console.log(url);
        if (!this.isFacebookEventPage(url)) {
          this.alertify.warning('Please enter a correct Facebook event page');
          event.stop();
          return;
        }
        if (this.spiderEventPages.any((x) => x.url === url)) {
          this.alertify.warning('You have already added this page');
          event.stop();
          return;
        }

        this.hubApiService.saveSpiderEventPages(this.hubName, url).subscribe((data) => {
          this.loadSpiderEventPages();
          event.complete();
        });
      },
    };

    this.modalService.show({
      component: InputModalComponent,
      providers: [
        { provide: InputModalActions, useValue: actions },
        {
          provide: InputModalData,
          useValue: new InputModalData(
            'Add Event Page URL',
            'e.g., https://www.facebook.com/rockandrollhalloffame/events',
            null,
            'SAVE',
            'CANCEL',
            true
          ),
        },
      ],
      panelClass: 'width-modal-2',
    });
  }

  public removeEventPage(page) {
    let actions = <ConfirmModalActions>{
      confirm: (event: ButtonTriggerEvent) => {
        this.hubApiService
          .deleteSpiderEventPage(this.hubName, page._id)
          .finally(event.complete)
          .subscribe(() => {
            this.loadSpiderEventPages();
          });
      },
    };

    let data = <ConfirmModalData>{
      confirmModalIcon: 'warning',
      confirmModalTitle: 'Alert',
      confirmModalDescription: 'Are you sure you want to delete this event page?',
      confirmModalConfirmButtonText: 'Delete',
      confirmModalCancelButtonText: 'Cancel',
      isAsync: true,
    };

    this.modalService.show({
      component: ConfirmModalComponent,
      providers: [
        { provide: ConfirmModalActions, useValue: actions },
        { provide: ConfirmModalData, useValue: data },
      ],
    });
  }

  public editEventPage(page) {
    let actions = <InputModalActions>{
      confirm: (event: ButtonTriggerEvent, url) => {
        if (!this.isFacebookEventPage(url)) {
          this.alertify.warning('Please enter a correct Facebook event page');
          event.stop();
          return;
        }
        if (this.spiderEventPages.any((x) => x.url === url)) {
          this.alertify.warning('You have already added this page');
          event.stop();
          return;
        }

        this.hubApiService.editSpiderEventPage(this.hubName, page, url).subscribe((data) => {
          this.loadSpiderEventPages();
          event.complete();
        });
      },
    };

    this.modalService.show({
      component: InputModalComponent,
      providers: [
        { provide: InputModalActions, useValue: actions },
        {
          provide: InputModalData,
          useValue: new InputModalData(
            'Edit Event Page URL',
            'e.g., https://www.facebook.com/rockandrollhalloffame/events',
            page.url,
            'SAVE',
            'CANCEL',
            true
          ),
        },
      ],
      panelClass: 'width-modal-2',
    });
  }

  public addEventBriteOrEventfulPage(event: ButtonTriggerEvent) {
    if (this.pageSource == 'eventbrite') {
      let organizer = this.GetOrganizerInfo(this.eventPage.facebookPageUrlOrName);

      if (!organizer) {
        event.complete();
        return;
      }

      this.hubApiService
        .addEventbriteOrganizerFeed(
          this.hubName,
          new AddEventBriteGeneralFeedCommand(
            organizer.organizerID,
            this.eventPage.displayTitle ? this.eventPage.displayTitle : organizer.name,
            this.eventPage.tags,
            this.hubName
          )
        )
        .finally(event.complete)
        .subscribe((result) => {
          let data = <ConfirmModalData>{
            confirmModalIcon: 'done',
            confirmModalTitle: 'Success',
            confirmModalDescription: 'Added the events of Eventbrite organizer success',
            confirmModalCancelButtonText: 'OK',
            isAsync: true,
          };

          if (result && result.error) {
            data.confirmModalTitle = 'Failed';
            data.confirmModalIcon = 'warning';
            if (result.error.code === 100) {
              data.confirmModalDescription = 'Uh-oh! Check your Eventbrite organizer settings! ';
            } else if (result.error.code === 803) {
              data.confirmModalDescription = result.error.message.replace('(#803)', 'Uh-oh!');
            }
          } else {
            this.eventFormGroup.markAsPristine();
            this.eventPage.displayTitle = null;
            this.eventPage.facebookPageUrlOrName = null;

            this.getHubPageFeeds();
          }

          let actions = <ConfirmModalActions>{};

          this.modalService.show({
            component: ConfirmModalComponent,
            providers: [
              { provide: ConfirmModalActions, useValue: actions },
              { provide: ConfirmModalData, useValue: data },
            ],
          });
        });
    } else if (this.pageSource == 'eventful') {
      let venue = this.GetVenueInfo(this.eventPage.facebookPageUrlOrName);

      if (!venue) {
        event.complete();
        return;
      }
      this.hubApiService
        .addEventfulVenueFeed(
          this.hubName,
          new AddEventBriteGeneralFeedCommand(
            venue.venueID,
            this.eventPage.displayTitle ? this.eventPage.displayTitle : venue.name,
            this.eventPage.tags,
            this.hubName
          )
        )
        .finally(event.complete)
        .subscribe((result) => {
          let data = <ConfirmModalData>{
            confirmModalIcon: 'done',
            confirmModalTitle: 'Success',
            confirmModalDescription: 'Added the events of Eventful venue success',
            confirmModalCancelButtonText: 'OK',
            isAsync: true,
          };

          if (result && result.error) {
            data.confirmModalTitle = 'Failed';
            data.confirmModalIcon = 'warning';
            if (result.error.code === 100) {
              data.confirmModalDescription = 'Uh-oh! Check your eventful venue settings! ';
            } else if (result.error.code === 803) {
              data.confirmModalDescription = result.error.message.replace('(#803)', 'Uh-oh!');
            }
          } else {
            this.eventFormGroup.markAsPristine();
            this.eventPage.displayTitle = null;
            this.eventPage.facebookPageUrlOrName = null;

            this.getHubPageFeeds();
          }

          let actions = <ConfirmModalActions>{};

          this.modalService.show({
            component: ConfirmModalComponent,
            providers: [
              { provide: ConfirmModalActions, useValue: actions },
              { provide: ConfirmModalData, useValue: data },
            ],
          });
        });
    }
  }

  public changeTooltip() {
    if (this.pageSource === constantTooltip.facebookString) {
      this.pageTooltip = constantTooltip.facebookTooltip;
    } else if (this.pageSource === constantTooltip.eventbriteString) {
      this.pageTooltip = constantTooltip.eventbriteTooltip;
    } else if (this.pageSource === constantTooltip.eventfulString) {
      this.pageTooltip = constantTooltip.eventfulTooltip;
    }
  }

  public locationStatus() {
    this.showSuccessInfo = false;
    this.getLocationStatus();
  }

  private GetOrganizerInfo(url: string): any {
    if (!url) {
      return null;
    }
    try {
      if (url.startsWith('https://www.eventbrite.com/o/')) {
        let organizer = url.split('?')[0].split('.com/o/')[1].split('/')[0].split('-');
        if (organizer.length > 1) {
          let id = organizer.splice(organizer.length - 1, 1);
          return {
            organizerID: id[0],
            name: organizer.join(' '),
          };
        }
      }
      this.modalService.showErrorModal('Please enter a valid eventbrite organizer url!');
      return null;
    } catch (ex) {
      this.modalService.showErrorModal('Please enter a valid eventbrite organizer url!');
      return null;
    }
  }

  private GetVenueInfo(url: string): any {
    if (!url) {
      return null;
    }
    try {
      if (url.indexOf('eventful.com/') > 0) {
        let temp = url.split('/venues/')[1].split('/');
        if (temp.length == 2) {
          return {
            venueID: temp[1],
            name: temp[0].split('-').join(' '),
          };
        }
      }
      this.modalService.showErrorModal('Please enter a valid eventful venue url!');
      return null;
    } catch (ex) {
      this.modalService.showErrorModal('Please enter a valid eventful venue url!');
      return null;
    }
  }

  public pageSourceChange(target) {
    this.pageSource = target.value;
    this.changeTooltip();
  }

  public findOnMapBySource(target) {
    this.locationSource = target.value;
    this.findOnMap();
  }

  public findOnMap() {
    if (this.autoCompletedAddress) {
      this.showSuccessInfo = false;
      this.eventLocation.lat = this.autoCompletedAddress.lat;
      this.eventLocation.lng = this.autoCompletedAddress.lng;
      // this.eventLocation.filterByCity = this.eventLocation.isFilterByCity ? this.locationSource === 'eventful' ? this.autoCompletedAddress.cityName : this.autoCompletedAddress.placeId : '';
      this.eventLocation.stateAbbr = this.autoCompletedAddress.stateAbbr;
      this.locationPlaceId =
        this.locationSource === 'eventful'
          ? this.autoCompletedAddress.cityName
          : this.autoCompletedAddress.placeId;
      this.locationPlaceCityState = `${this.autoCompletedAddress.cityName}, ${this.autoCompletedAddress.stateAbbr}, ${this.autoCompletedAddress.country}`;
      this.eventLocation.filterByCity = this.eventLocation.isFilterByCity
        ? this.locationPlaceCityState
        : null;
      this.zoom = ConfigService.config.google.locationMapZoom;
      this.isShowMarker = true;

      this.getLocationStatus();
    } else {
      this.resetMap();
    }
  }

  public setPlaceSource() {
    // this is a function for the convenience of changing place source from client dashboard, so this google key is fixed (this feature will be removed later)
    this.hubApiService
      .setPlaceSource(this.hubName, this.placeSource, 'AIzaSyBTK-7XADsofCdPvDWP4Rh2QzSK6t-POaw')
      .subscribe(() => {
        this.alertify.successfully('Change place source');
      });
  }

  public addLocation(event: ButtonTriggerEvent) {
    if (this.checkIfExceedLimit('location')) {
      event.complete();
      return;
    }

    this.inAddingLocationFeed = true;
    this.showSuccessInfo = false;

    if (this.isFeedExisted) {
      this.hubApiService
        .removeLocationFeed(this.hubName, this.eventLocation.feedId, this.locationSource)
        .finally(() => {
          event.complete();
          this.inAddingLocationFeed = false;
        })
        .subscribe(() => {
          this.locationFormGroup.markAsPristine();
          this.showSuccessInfo = true;

          setTimeout(() => {
            this.showSuccessInfo = false;
            this.infoWindow.close();
            this.addressInput.clear();

            this.getHubLocations();
          }, 1500);
        });
      return;
    }
    if (this.locationSource == 'facebook') {
      // let points = GeoService.getPoints(this.eventLocation.lat, this.eventLocation.lng, this.eventLocation.radius);
      // console.log(points);

      this.hubApiService
        .addFacebookLocationFeed(
          this.hubName,
          new AddFacebookLocationFeedCommand(
            this.eventLocation.address,
            this.eventLocation.displayTitle
              ? this.eventLocation.displayTitle
              : this.autoCompletedAddress.address,
            this.hubName,
            this.eventLocation.filterByCity,
            [], //points,
            this.eventLocation.lat,
            this.eventLocation.lng,
            this.eventLocation.radius,
            this.eventLocation.stateAbbr,
            this.eventLocation.tags
          )
        )
        .finally(() => {
          event.complete();
          this.inAddingLocationFeed = false;
          this.eventLocation.filterByCity = null;
          this.getHubLocations();
        })
        .subscribe(() => {
          this.locationFormGroup.markAsPristine();
          this.showSuccessInfo = true;
        });
    } else if (this.locationSource === 'google') {
      GeoService.reset();
      let points = GeoService.getPoints(
        this.eventLocation.lat,
        this.eventLocation.lng,
        (this.eventLocation.radius * this.mileToMeters) / 1000
      );
      console.log(`points.length: ${points.length}`);
      console.log(`this.eventLocation.filterByCity: ${this.eventLocation.filterByCity}`);

      this.hubApiService
        .addGoogleLocationFeed(
          this.hubName,
          new AddFacebookLocationFeedCommand(
            this.eventLocation.address,
            this.eventLocation.displayTitle
              ? this.eventLocation.displayTitle
              : this.autoCompletedAddress.address,
            this.hubName,
            this.eventLocation.filterByCity,
            points,
            this.eventLocation.lat,
            this.eventLocation.lng,
            this.eventLocation.radius,
            this.eventLocation.stateAbbr,
            this.eventLocation.tags,
            'google',
            this.selectedGoogleCategories.map((y) => y.value)
          )
        )
        .finally(() => {
          event.complete();
          this.eventLocation.filterByCity = null;
          this.getHubLocations();
        })
        .subscribe((data) => {
          if (data) {
            if (data.status === 'under pulling') {
              this.alertify.warning(data.msg);
              this.inAddingLocationFeed = false;
            } else if (data.status === 'pulling') {
              let getPullingStatus = setInterval(() => {
                this.hubApiService.checkPullingGooglePlaceStatus(this.hubName).subscribe((data) => {
                  if (data && !data.isPulling) {
                    clearInterval(getPullingStatus);
                    this.inAddingLocationFeed = false;
                    this.locationFormGroup.markAsPristine();
                    this.showSuccessInfo = true;
                    this.percentage = null;
                  } else {
                    this.percentage = data.progress;
                  }
                });
              }, 10000);
            }
          }
          event.complete();
        });
    } else if (this.locationSource == 'eventbrite') {
      this.hubApiService
        .addEventBriteLocationFeed(
          this.hubName,
          new AddFacebookLocationFeedCommand(
            this.eventLocation.address,
            this.eventLocation.displayTitle
              ? this.eventLocation.displayTitle
              : this.autoCompletedAddress.address,
            this.hubName,
            null,
            null,
            this.eventLocation.lat,
            this.eventLocation.lng,
            this.eventLocation.radius,
            this.eventLocation.tags,
            config.eventbrite
          )
        )
        .finally(() => {
          event.complete();
          this.inAddingLocationFeed = false;
        })
        .subscribe(() => {
          this.locationFormGroup.markAsPristine();
          this.showSuccessInfo = true;
          this.getHubLocations();
        });
    } else if (this.locationSource == 'eventful') {
      this.hubApiService
        .addEventfulLocationFeed(
          this.hubName,
          new AddFacebookLocationFeedCommand(
            this.eventLocation.address,
            this.eventLocation.displayTitle
              ? this.eventLocation.displayTitle
              : this.autoCompletedAddress.address,
            this.hubName,
            this.eventLocation.filterByCity,
            null,
            this.eventLocation.lat,
            this.eventLocation.lng,
            this.eventLocation.radius,
            this.eventLocation.stateAbbr,
            this.eventLocation.tags,
            'eventful'
          )
        )
        .finally(() => {
          event.complete();
          this.inAddingLocationFeed = false;
        })
        .subscribe(() => {
          this.locationFormGroup.markAsPristine();
          this.showSuccessInfo = true;
          this.getHubLocations();
        });
    }
  }

  private checkIfExceedLimit(type) {
    let isExceedLimit = false;
    if (type === 'location') {
      if (this.hubLocations && this.hubLocations.length) {
        // adding place location feed
        if (this.locationSource === 'facebook' || this.locationSource === 'google') {
          if (
            this.hubLocations.filter(
              (x) => x.socialName === 'facebook' || x.socialName === 'google'
            ).length >= config.maxLocationFeedLimit
          ) {
            isExceedLimit = true;
          }
        } else {
          // adding event location feed
          if (
            this.hubLocations.filter(
              (x) => x.socialName === 'eventbrite' || x.socialName === 'eventful'
            ).length >= config.maxLocationFeedLimit
          ) {
            isExceedLimit = true;
          }
        }
      }
    } else if (type === 'spider') {
      if (this.pagesMax === 0) {
        isExceedLimit = false;
      } else if (
        this.spiderEventPages &&
        this.spiderEventPages.filter((x) => ['facebook'].indexOf(x.socialName) >= 0).length >=
          this.pagesMax
      ) {
        isExceedLimit = true;
      }
    }

    if (isExceedLimit) {
      let data = <ConfirmModalData>{
        confirmModalIcon: 'warning',
        confirmModalTitle: 'Warning',
        confirmModalDescription: `The number of ${
          type === 'location' ? 'locations' : 'event pages'
        } you have added has exceeded the limit, please contact our team, emailing <a href="mailto:aline@iti-digital.com">aline@iti-digital.com</a> or call us at 912-267-1558</p>`,
        confirmModalCancelButtonText: 'OK',
        isAsync: true,
      };

      let actions = <ConfirmModalActions>{};

      this.modalService.show({
        component: ConfirmModalComponent,
        providers: [
          { provide: ConfirmModalActions, useValue: actions },
          { provide: ConfirmModalData, useValue: data },
        ],
      });
      return true;
    }

    return false;
  }

  private getHubPageFeeds() {
    let times = 0;
    let getFeeds = () =>
      this.hubApiService
        .getPageFeeds(this.hubName)
        .catch((err) => {
          if (times < 3) {
            getFeeds();
          }
          times++;
          return Observable.throw(err.statusText);
        })
        .subscribe((data) => {
          this.hubPages = data;
          let pageCommand = new HubFacebookFeedsCommand(data);
          this.hubFacebookFeedsStore.pagesCommand.next(pageCommand);
        });
    getFeeds();
  }

  private getHubLocations() {
    let times = 0;
    this.isLoadingFeeds = true;
    let getFeeds = () =>
      this.hubApiService
        .getLocationFeeds(this.hubName)
        .catch((err) => {
          if (times < 3) {
            getFeeds();
          }
          times++;
          return Observable.throw(err.statusText);
        })
        .subscribe((data) => {
          this.isLoadingFeeds = false;
          this.hubLocations = data;
          this.hubFacebookLocationFeedsStore.locationCommand.next(
            new HubFacebookFeedsCommand(this.hubLocations)
          );
        });
    getFeeds();
  }

  private getLocationStatus() {
    this.hubApiService
      .getLocationStatus(
        this.hubName,
        this.autoCompletedAddress.lat,
        this.autoCompletedAddress.lng,
        this.locationSource
      )
      .subscribe((result) => {
        if (result) {
          this.isFeedExisted = result.connected;
          if (this.isFeedExisted) {
            this.eventLocation.displayTitle = result.title;
          } else {
            this.eventLocation.displayTitle = this.autoCompletedAddress.address;
          }
          if (result.radius) {
            this.eventLocation.radius = result.radius / config.mileToMeters;
          }
          this.eventLocation.feedId = result.feedId;
        }
      });
  }

  private resetMap() {
    this.eventLocation.lat = ConfigService.config.google.USCenter.lat;
    this.eventLocation.lng = ConfigService.config.google.USCenter.lng;
    this.eventLocation.filterByCity = null;
    this.isShowMarker = false;
    this.zoom = ConfigService.config.google.fullUSMapZoom;
  }

  private getFBID(link: string) {
    if (link.startsWith('@')) {
      return link;
    }
    if (!link || link.indexOf('https://www.facebook.com/') === -1) {
      return null;
    }

    let fbSeg = link.split('https://www.facebook.com/')[1];
    let id = null;
    let seg = fbSeg.split('/');
    if (seg[0] === 'pages') {
      id = seg[seg.length - 1];
      if (id.indexOf('-') >= 0) {
        let dashSeg = id.split('-');
        id = dashSeg[dashSeg.length - 1];
      }
    } else if (seg[0].indexOf('-') >= 0) {
      let dashSeg = seg[0].split('-');
      id = dashSeg[dashSeg.length - 1];
    } else {
      id = seg[0];
    }
    return id;
  }

  deleteLocationFeed(location: HubFeed) {
    let actions = <ConfirmModalActions>{
      confirm: (feed: ButtonTriggerEvent) => {
        this.hubApiService
          .removeLocationFeed(this.hubName, location.id, location.socialName)
          .finally(feed.complete)
          .subscribe(() => {
            this.getHubLocations();
          });
      },
    };

    let data = <ConfirmModalData>{
      confirmModalIcon: 'warning',
      confirmModalTitle: 'Alert',
      confirmModalDescription: 'Are you sure you want to remove this Location?',
      confirmModalConfirmButtonText: 'Remove',
      confirmModalCancelButtonText: 'Cancel',
      isAsync: true,
    };

    this.modalService.show({
      component: ConfirmModalComponent,
      providers: [
        { provide: ConfirmModalActions, useValue: actions },
        { provide: ConfirmModalData, useValue: data },
      ],
    });
  }

  public deleteEventFeed(page: HubFeed) {
    let actions = <ConfirmModalActions>{
      confirm: (feed: ButtonTriggerEvent) => {
        this.hubApiService
          .removePageFeed(this.hubName, page.id)
          .finally(feed.complete)
          .subscribe(() => {
            this.getHubPageFeeds();
          });
      },
    };

    let data = <ConfirmModalData>{
      confirmModalIcon: 'warning',
      confirmModalTitle: 'Alert',
      confirmModalDescription: 'Are you sure you want to remove this page?',
      confirmModalConfirmButtonText: 'Remove',
      confirmModalCancelButtonText: 'Cancel',
      isAsync: true,
    };

    this.modalService.show({
      component: ConfirmModalComponent,
      providers: [
        { provide: ConfirmModalActions, useValue: actions },
        { provide: ConfirmModalData, useValue: data },
      ],
    });
  }

  private isFacebookEventPage(url: string) {
    if (!url) return false;
    if (url.indexOf('facebook.com') < 0) return false;
    if (url.indexOf('/events') < 0) return false;

    return true;
  }
}



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/hub/edit.account/content.management/content.management.component.ts